import { API_GET_BANNER_MESSAGE } from '../urls'
import { getUploadHeaders } from './headerconstants'
import { runtimeConfig } from '../runtimeConfig'
const USER_GUIDE_URL = runtimeConfig.VITE_USER_GUIDE_URL

export const fetchBannerState = ({
  accessToken,
  idToken,
  projectId,
}: {
  accessToken: string
  idToken: string
  projectId: string
  user_email: string
}) =>
  fetch(`${USER_GUIDE_URL}${API_GET_BANNER_MESSAGE}`, {
    method: 'GET',
    headers: getUploadHeaders(accessToken, idToken, projectId),
  })
